import { App, CategoryInput, PosProduct, Product } from 'generated/graphql';
import { createContext, useContext } from 'react';
import { type Items } from 'types';
import { type UniqueIdentifier } from '@dnd-kit/core';

export type CategoryContextProps = {
  collapsedCategories: string[];
  handleToggleCategoryCollapse: (id: string) => void;
  isLoading?: boolean;
  changedProductIds: string[];
  changedCategoryIds: string[];
  addChangedCategoryIds: (ids: string[]) => void;
  apps: App[];
  items: Items;
  setItems: React.Dispatch<React.SetStateAction<Items>>;
  containers: UniqueIdentifier[];
  setContainers: React.Dispatch<React.SetStateAction<UniqueIdentifier[]>>;
  updateCategory: (categoryInput: CategoryInput) => void;
  addNewCategory: (name: string) => void;
  deleteCategory: (categoryMmId: UniqueIdentifier) => void;
  reorderCategories: (newIndex: number, previousIndex: number) => void;
  reorderProducts: (
    draftItemId: UniqueIdentifier,
    newIndex: number,
    previousIndex: number,
    previousCategoryMmId: UniqueIdentifier,
    newCategoryMmId?: UniqueIdentifier
  ) => void;
  addNewInlineProduct: (name: PosProduct | Product, categoryId: UniqueIdentifier) => void;
  deleteProduct: (categoryMmId: UniqueIdentifier, productToDelete: Product) => void;
  menuIndex: number;
};

export const CategoryContext = createContext<CategoryContextProps | null>(null);

export const useCategoryContext = (): CategoryContextProps => {
  return useContext(CategoryContext) as CategoryContextProps;
};
